import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm, change, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";

import { Box } from "rebass";
import {
  Toolbar,
  GET_LIST,
  CREATE,
  showNotification as showNotificationAction
} from "admin-on-rest";
import { push as pushAction } from "react-router-redux";
import Paper from "material-ui/Paper";

import getDefaultValues from "../../components/form/getDefaultValues";
import { ValuesForm, SearchMarketerCampaignChip } from "../../components";
import { DivFormContainer } from "../styled";
import { RestClient } from "../../restClient";

class KolCreate extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      if (!values.id || values.id === -1) {
        this.props.showNotification("Please Add User", "warning");
      } else {
        this.AddKol(values);
      }
    });
  constructor(props) {
    super(props);
    // const { record } = props;
    this.state = {
      usersRecord: []
    };
    // if (record && record.users && record.users.length > 0) {
    //   this.getUsers(record.users);
    // }
  }
  getUsers(users) {
    RestClient(GET_LIST, "marketers", {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "first_name", order: "ASC" },
      filter: {}
    })
      .then(items => {
        if (items && items.data) {
          const res = items.data.filter(function(el) {
            return users.indexOf(el.id) >= 0;
          });
          this.setState({
            usersRecord: res
          });
        }
      })
      .catch(e => {
        // resolve([]);
      });
  }

  AddKol(values) {
    const { match } = this.props;
    const paramsId = match.params && match.params.id ? match.params.id : "";
    RestClient(CREATE, `campaignMarketers/${paramsId}`, {
      data: values
    })
      .then(items => {
        if (items && items.data) {
          const url = this.props.match.url;
          const paramsUrl = url.replace("/create", "");
          this.props.showNotification("Element Created");
          this.props.push(paramsUrl);
        } else {
          this.props.showNotification("Please try again", "warning");
        }
      })
      .catch(e => {
        this.props.showNotification("Please try again", "warning");
        // console.log(e);
      });
  }
  onChangeUsers = Users => {
    const data = Users.map(item => {
      return item.id;
    });
    if (data.length < 1) {
      this.props.updateKol(-1);
    } else {
      this.props.updateKol(data[0]);
    }
  };
  render() {
    const { invalid, record, submitOnEnter, toolbar } = this.props;
    const users = record && record.users ? record.users : [];
    return (
      <Paper zDepth={1}>
        <Box w={[1]} p={[1]} pb={[0]}>
          Details
        </Box>
        <div>
          <form className="simple-form">
            <DivFormContainer>
              <Box w={[1]} px={[1, 2]}>
                <SearchMarketerCampaignChip
                  data={this.state.usersRecord}
                  nameUsers={users}
                  onChangeUser={this.onChangeUsers.bind(this)}
                  singleInput={true}
                />
              </Box>
            </DivFormContainer>
            {toolbar &&
              React.cloneElement(toolbar, {
                handleSubmitWithRedirect: this.handleSubmitWithRedirect,
                invalid,
                submitOnEnter
              })}
            <ValuesForm isDebug={false} formName={"record-form"} />
          </form>
        </div>
      </Paper>
    );
  }
}

KolCreate.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func,
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func,
  translate: PropTypes.func,
  showNotification: PropTypes.func
};

KolCreate.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};
const selector = formValueSelector("record-form");
const enhance = compose(
  connect(
    (state, props) => {
      const users = selector(state, "id");
      return {
        initialValues: getDefaultValues(state, props),
        users
      };
    },
    {
      updateKol: id => change("record-form", "id", id),
      showNotification: showNotificationAction,
      push: pushAction
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  })
);

export default enhance(KolCreate);



// WEBPACK FOOTER //
// ./src/campaigns/kol/KolCreate.js